module.exports = __webpack_public_path__ + "img/ico-arrow-prev.e1df9790.svg";